export const MULTILANG_HOMOPHONES: Record<string, Record<string, string[]>> = {
  // INGLÊS
  en: {
    their: ['there', "they're"],
    there: ['their', "they're"],
    "they're": ['their', 'there'],
    to: ['too', 'two', '2'],
    too: ['to', 'two', '2'],
    two: ['to', 'too', '2'],
    hear: ['here'],
    here: ['hear'],
    sea: ['see', 'c'],
    see: ['sea', 'c'],
    c: ['see', 'sea'],
    b: ['be', 'bee'],
    be: ['bee', 'b'],
    bee: ['be', 'b'],
    eye: ['i', 'aye'],
    i: ['eye', 'aye'],
    p: ['pea', 'pee'],
    tea: ['tee', 't'],
    t: ['tea', 'tee'],
    u: ['you'],
    you: ['u', 'ewe'],
    r: ['are', 'our'],
    are: ['r', 'our'],
    our: ['hour', 'are'],
    hour: ['our'],
    buy: ['by', 'bye'],
    by: ['buy', 'bye'],
    bye: ['buy', 'by'],
    right: ['write'],
    write: ['right'],
    no: ['know'],
    know: ['no'],
    knew: ['new'],
    new: ['knew'],
    peace: ['piece'],
    piece: ['peace'],
    for: ['four', '4', 'fore'],
    four: ['for', '4'],
    son: ['sun'],
    sun: ['son'],
    one: ['won'],
    won: ['one'],
    meet: ['meat'],
    meat: ['meet'],
    wait: ['weight'],
    weight: ['wait'],
    break: ['brake'],
    brake: ['break'],
    whole: ['hole'],
    hole: ['whole'],
    flour: ['flower'],
    flower: ['flour'],
    wear: ['where'],
    where: ['wear'],
    weather: ['whether'],
    whether: ['weather'],
    allowed: ['aloud'],
    aloud: ['allowed'],
    which: ['witch'],
    witch: ['which'],
    male: ['mail'],
    mail: ['male'],
    night: ['knight'],
    knight: ['night'],
    plain: ['plane'],
    plane: ['plain'],
    stair: ['stare'],
    stare: ['stair'],
    suite: ['sweet'],
    sweet: ['suite'],
    week: ['weak'],
    weak: ['week'],
    tail: ['tale'],
    tale: ['tail'],
    sail: ['sale'],
    sale: ['sail']
  },

  // FRANCÊS
  fr: {
    et: ['est', 'ai', 'es'],
    est: ['et', 'es', 'ai'],
    a: ['à'],
    à: ['a'],
    ou: ['où'],
    où: ['ou'],
    on: ['ont'],
    ont: ['on'],
    son: ['sont'],
    sont: ['son'],
    ce: ['se'],
    se: ['ce'],
    ces: ['ses', "c'est", "s'est", 'sais', 'sait'],
    ses: ['ces', "c'est", "s'est", 'sais', 'sait'],
    "c'est": ['ces', 'ses', "s'est", 'sais', 'sait'],
    "s'est": ["c'est", 'ces', 'ses'],
    la: ['là', "l'a"],
    là: ['la', "l'a"],
    ni: ['nids', 'nie', 'nies', 'nient', "n'i"],
    aux: ['eau', 'eaux', 'haut', 'hauts', 'ô', 'o'],
    eau: ['aux', 'eaux', 'haut', 'hauts'],
    vert: ['vers', 'ver', 'verre'],
    vers: ['vert', 'ver', 'verre'],
    verre: ['vert', 'vers', 'ver'],
    sans: ['sang', 'cent', 'cents', "s'en"],
    sang: ['sans', 'cent', 'cents'],
    cent: ['sans', 'sang', 'cents'],
    faim: ['fin'],
    fin: ['faim'],
    mer: ['mère', 'maire'],
    mère: ['mer', 'maire'],
    peine: ['pêne'],
    point: ['poing'],
    temps: ['tant', 'taon'],
    tant: ['temps', 'taon'],
    tout: ['toux'],
    toux: ['tout']
  },

  // ESPANHOL
  es: {
    a: ['ha', 'ah'],
    ha: ['a', 'ah'],
    hay: ['ahí', 'ay'],
    ahí: ['hay', 'ay'],
    ay: ['hay', 'ahí'],
    hecho: ['echo'],
    echo: ['hecho'],
    hasta: ['asta'],
    asta: ['hasta'],
    abría: ['habría'],
    habría: ['abría'],
    tubo: ['tuvo'],
    tuvo: ['tubo'],
    hola: ['ola'],
    ola: ['hola'],
    hora: ['ora'],
    bello: ['vello'],
    vello: ['bello'],
    bienes: ['vienes'],
    vienes: ['bienes'],
    botar: ['votar'],
    votar: ['botar'],
    caza: ['casa'],
    casa: ['caza'],
    cocer: ['coser'],
    coser: ['cocer'],
    savia: ['sabia'],
    sabia: ['savia'],
    grabar: ['gravar'],
    gravar: ['grabar'],
    basta: ['vasta'],
    vasta: ['basta'],
    ciego: ['siego'],
    siego: ['ciego'],
    hacia: ['asia'],
    hierba: ['yerba'],
    vaya: ['valla', 'baya'],
    valla: ['vaya', 'baya']
  },

  // ITALIANO
  it: {
    ha: ['a', 'ah'],
    a: ['ha', 'ah'],
    hanno: ['anno'],
    anno: ['hanno'],
    ho: ['o', 'oh'],
    o: ['ho', 'oh'],
    hai: ['ai'],
    ai: ['hai'],
    luna: ["l'una"],
    cura: ["c'ura"],
    elice: ["l'elice"],
    danno: ["d'anno"],
    fiera: ["f'iera"]
  },

  // PORTUGUÊS
  pt: {
    a: ['há', 'ah'],
    há: ['a', 'ah'],
    sessão: ['seção', 'cessão'],
    seção: ['sessão', 'cessão'],
    cessão: ['sessão', 'seção'],
    censo: ['senso'],
    senso: ['censo'],
    acento: ['assento'],
    assento: ['acento'],
    cheque: ['xeque'],
    xeque: ['cheque'],
    concerto: ['conserto'],
    conserto: ['concerto'],
    coser: ['cozer'],
    cozer: ['coser'],
    espiar: ['expiar'],
    expiar: ['espiar'],
    taxa: ['tacha'],
    tacha: ['taxa'],
    hera: ['era'],
    era: ['hera'],
    houve: ['ouve'],
    ouve: ['houve'],
    noz: ['nós'],
    nós: ['noz'],
    ruço: ['russo'],
    russo: ['ruço']
  }
};
